/**
 * ET TIDSPUNKT I ET SVAR ER ALLTID ISO 8601 I UTC (AI-ANALYSE §8.2: «datofelt som er z.string() får
 * riktig iso-type»).
 *
 * Rundt nitti svarfelt var `z.string()`. Noen av dem fikk Postgres' egen tekstform rett fra driveren
 * (`2026-10-26 18:00:00.123456+00`), som Chrome leser og Safari ikke gjør, og som OpenAPI ikke kunne
 * kalle `date-time`. `wireInstant` godtar begge formene inn og sender alltid `…Z` ut, så kontrakten er
 * sann uten at hver tjeneste må huske `toISOString()`. Bare på felt som er målt å være `timestamptz`
 * (B1-rapporten lister dem); et klokkeslett eller en kalenderdag skal aldri hit.
 */
import { z } from 'zod';

/** `2026-10-26 18:00:00.123456+00` → `2026-10-26T18:00:00.123456+00:00`, så `Date.parse` er standard. */
function asIso(value: string): string {
  const withT = /^\d{4}-\d{2}-\d{2} /.test(value) ? value.replace(' ', 'T') : value;
  return withT.replace(/([+-]\d{2})$/, '$1:00');
}

export const wireInstant = z
  .string()
  .transform((value, ctx) => {
    const ms = Date.parse(asIso(value));
    if (Number.isNaN(ms)) {
      ctx.addIssue({ code: 'custom', message: 'Expected a timestamp.' });
      return z.NEVER;
    }
    return new Date(ms).toISOString();
  })
  .pipe(z.iso.datetime());
